<!-- app入口页面 -->
<template>
  <div id='app'>
    <router-view/>
  </div>
</template>

<script>
import sniffer from '@/utils/sniffer'

export default {
  data () {
    return {
    }
  },
  components: {
  },
  mounted () {
    sniffer.init()
  },
  methods: {}
}
</script>
<style lang='scss'>
@import '@/styles/common.scss';
</style>

<style scoped lang='scss'>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $base-font-color;
  // color: $main-color;
  // background-color: $main-bg-color;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
